module.exports = __webpack_public_path__ + "img/img4.e828a163.png";